import http from './http';

export async function fileInfo(id) {
  const { data } = await http.get(`/api/files/${id}/info`);
  return data;
}

